<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"    
    :width="$vuetify.breakpoint.mdAndDown ? '95%' : '80%'"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"    
    :readOnly="readOnly"
    :editIcon="editIcon"
    :isTextButton="isTextButton"
    :textButton="textButton"
    :modelNameSingular="modelNameSingular"
  >
  <!-- :editTitle="editTitle"  comentei pq tava dando erro, estava no bloco acima -->
  <!-- :readTitle="readTitle" mesma coisa -->
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry" 
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
// import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: false,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],      
    };
  },
  props: {
    entry: Object,
    // readTitle: {
    //   type: String,
    //   default: "Visualização de Operação"
    // },
    readOnly: {
      type: Boolean,
      default: false
    },
    isTextButton: {
      type: Boolean,
      default: false
    },
    textButton: {
      type: String,
    },
    editIcon: {
      type: String,
      default: "mdi-pencil"
    },
    extraData: {},
    // editTitle: {
    //   type: String,
    //   default: "Edição de Operação"
    // },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadEntry: function(){
      this.editableEntry = _.cloneDeep(this.entry);
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.$refs.baseEdit.closeDialog();

        this.editableEntry.storageItemLots = [];
        console.log("ids", this.editableEntry);
        var self = this;
        this.editableEntry.storageItemLotIdsAttribute.forEach(function(id, i){
          self.editableEntry.storageItemLots.push(self.extraData.accountContext.allItemsInStorage.find( (item) => item.id == id));
        });

        this.entry.name = this.editableEntry.name;
        this.entry.storageItemLots = this.editableEntry.storageItemLots;
        this.entry.storageItemLotIdsAttribute = this.editableEntry.storageItemLotIdsAttribute;

        this.$emit("entry-updated", this.entry);
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

</script>

<style scoped></style>
